
<template>
  <Loader v-if="loader" />
  <div class="card">
      <DataTable :value="invoices" :paginator="true" :rows="10" :filters="filters" 
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          :rowsPerPageOptions="[10,20,50]" responsiveLayout="scroll"
          currentPageReportTemplate="{first} a {last} di {totalRecords}">
          <template #header>
              <div class="table-header p-d-flex p-flex-column p-flex-md-row p-jc-md-end">
                  <span class="p-input-icon-left">
                      <i class="pi pi-search" />
                      <InputText type="search" v-model="filters['global'].value" placeholder="Cerca..." />
                  </span>
              </div>
          </template>
          <template #empty>
              <div class="text-center">Nessun dato trovato.</div>
          </template>
          <Column field="FNumeroFattura" header="Fattura" :sortable="true"></Column>
          <Column field="TDataEmissioneFattura" header="Data emissione" :sortable="true"></Column>
          <Column field="TCodiceTipoFattura" header="Tipo fattura" :sortable="true">
            <template #body="{data}">
             <div v-if="data.TCodiceTipoFattura == 'C'" v-tooltip.bottom="'Fattura di ciclo'">{{data.TCodiceTipoFattura}}</div>     
             <div v-if="data.TCodiceTipoFattura == 'R'" v-tooltip.bottom="'Fattura di rettifica'">{{data.TCodiceTipoFattura}}</div>     
             <div v-if="data.TCodiceTipoFattura == 'U'" v-tooltip.bottom="'Fattura ulteriori prestazioni'">{{data.TCodiceTipoFattura}}</div>     
            </template>
          </Column> 
          <Column field="FCodiceVoceFatturata" header="Voce fattura" :sortable="true"></Column>
          <Column field="FImportoBollo" header="Bollo" :sortable="true"></Column>
          <Column field="FTotaleImponibileFattura" header="Imponibile" :sortable="true">
            <template #body="{data}">
              {{data.FTotaleImponibileFattura.toFixed(2)}}     
            </template>
          </Column>
          <Column field="FTotaleIVAFattura" header="Iva" :sortable="true">
            <template #body="{data}">
              {{data.FTotaleIVAFattura.toFixed(2)}}     
            </template>
          </Column>
          <Column field="FTotaleFattura" header="Totale" :sortable="true">
            <template #body="{data}">
              <span class="text-primary">{{data.FTotaleFattura.toFixed(2)}}     </span>
            </template>
          </Column>
          <Column field="company_name" header="Azienda" :sortable="true"></Column>
          <Column field="fornitore" header="Fornitore" :sortable="true"></Column>
          <Column :exportable="false">
              <template #body="{data}">
                  <Button  icon="pi pi-eye" class="p-button-rounded p-button-success mr-2" @click="getDetail(data.id)" />
              </template>
          </Column> 
      </DataTable>
  </div>

  <!-- Dialog dettagli expandable -->
  <Dialog  v-model:visible="tableDetail" :style="{width: '80%'}" header="Dettagli" :maximizable="true" :modal="true" class="p-fluid">
      <div class="formgrid grid">
        <div class="field col-12">
           <DataTable :value="details" v-model:expandedRows="expandedRows" dataKey="id" responsiveLayout="scroll">
            <Column :expander="true" headerStyle="width: 3rem" />
            <Column field="DCodicePod" header="Pod" sortable></Column>
            <Column field="DDTTensione" header="Tensione" sortable></Column>
            <Column field="DDCTariffaDistribuzione" header="Cluster" sortable></Column>
            <Column  header="Totale imponibile dettagli" sortable>
              <template #body="{data}">
                {{(data.details_pod.reduce((acc, el) => acc + el.DImporto, 0)).toFixed(2)}}     
              </template>
            </Column>
            <template #expansion="slotProps">
                <div class="orders-subtable">
                    <DataTable :value="slotProps.data.details_pod" responsiveLayout="scroll">
                        <Column field="DCodiceIVA" header="Iva" sortable></Column>
                        <Column field="DPeriodoCompetenzaDa" header="Competenza da" sortable></Column>
                        <Column field="DPeriodoCompetenzaA" header="Competenza a" sortable></Column>
                        <Column field="DComponente" header="Componente" sortable></Column>
                        <Column field="DCorrispettivoUnitario" header="Unitario" sortable></Column>
                        <Column field="DQuantita" header="Quantità" sortable></Column>
                        <Column field="DImporto" header="Imponibile" sortable>
                          <template #body="{data}">
                            {{data.DImporto.toFixed(2)}}     
                          </template>
                        </Column>
                    </DataTable>
                </div>
            </template>
            <template #empty>
              <div class="text-center">Nessun dato trovato.</div>
          </template>
        </DataTable>
        </div>
      </div>

      <template #footer>
        <div class="mt-2 text-right">
          <Button label="Chiudi" icon="pi pi-times" class="p-button-text" @click="tableDetail = false"/>
        </div>
      </template>
  </Dialog>

</template>

<script>
import Service from '@/services/ask-pratiche/pratiche-service'
import { ref, onMounted, getCurrentInstance  } from 'vue';
import { FilterMatchMode } from 'primevue/api';
import Loader from '@/components/Loader.vue'


export default {
    components: {
      Loader
    },
     setup() {

        const loader = ref(false)
        const invoices = ref([]);
        const filters = ref({
            'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
        });
        const self = getCurrentInstance();
        self.$eventBus = self.appContext.config.globalProperties.$eventBus
        self.$http = self.appContext.config.globalProperties.$http
        const service = new Service(self.$http, self.$eventBus)
        const tableDetail = ref(false);
        const details = ref([])
        const expandedRows = ref([]);

        onMounted(() => {       
            getData()               
        })
        const getData = () => {
            loader.value = true
            service.getAllFatture().then((res) => {
                invoices.value = res.items      
            }).finally(() => {
                loader.value = false
            })
        }

        const getDetail = (id) => {
          loader.value = true
          service.getFattureDetails(id).then((res) => {
            details.value = res.items
            tableDetail.value = true
          }).finally(() => {
              loader.value = false
            })
        }

        return { 
          invoices,
           loader, 
           service, 
           getData, 
           filters, 
           getDetail,
           tableDetail,
           details,
           expandedRows
        }
    }
}
</script>

<style scoped>

</style>
